import React from 'react';
import styled from 'styled-components';

const MarkdownIt = require('markdown-it');
const markdownParser = new MarkdownIt({ html: false, linkify: false, breaks: false });

const Page = styled.div`
  min-height: 100vh;
  background: #f6f7fb;
  color: #263442;
`;

const EmbeddedPage = styled(Page)`
  min-height: auto;
`;

const Main = styled.main`
  max-width: 920px;
  padding: 28px 48px 48px;
`;

const EmbeddedMain = styled(Main)`
  max-width: none;
  padding: 20px 24px 24px;
`;

const MarkdownBody = styled.section`
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid #e6e8ef;
  border-radius: 6px;
  color: #3f4f62;
  font-size: 14px;
  line-height: 22px;

  h1 {
    margin: 0 0 14px;
    color: #1f2d3d;
    font-size: 26px;
    line-height: 34px;
    font-weight: 600;
  }

  h2 {
    margin: 22px 0 12px;
    color: #263442;
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
  }

  h2:first-child {
    margin-top: 0;
  }

  p {
    margin: 0 0 14px;
    font-size: 15px;
    line-height: 24px;
  }

  ul,
  ol {
    margin: 0 0 14px;
    padding-left: 20px;
  }

  li {
    margin: 6px 0;
  }

  img {
    display: block;
    max-width: 100%;
    margin: 0 0 18px;
    border: 1px solid #e6e8ef;
    border-radius: 6px;
  }

  table {
    width: 100%;
    margin: 0 0 18px;
    border-collapse: collapse;
  }

  th,
  td {
    padding: 10px 12px;
    border: 1px solid #e6e8ef;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #f6f7fb;
    color: #263442;
    font-weight: 600;
  }
`;

export interface PromptTipsContentProps {
  markdown?: string;
  embedded?: boolean;
}

export function renderPromptTipMarkdown(markdown: string) {
  return markdownParser.render(markdown || '');
}

export function PromptTipsContent({ markdown = '', embedded = false }: PromptTipsContentProps) {
  const Root = embedded ? EmbeddedPage : Page;
  const PageMain = embedded ? EmbeddedMain : Main;

  if (!markdown) return <Root />;

  return (
    <Root>
      <PageMain>
        <MarkdownBody dangerouslySetInnerHTML={{ __html: renderPromptTipMarkdown(markdown) }} />
      </PageMain>
    </Root>
  );
}

export default React.memo(PromptTipsContent);
